<template>
  <div id="top">
    <headNav :gray="gray"></headNav>
    <!--container-->
    <div class="innerWrapper">
      <h1>Contact us</h1>
      <h2>
        Reach out to us if you have enquiries or assistance needed by contacting
        {{ tenant != "" ? tenant.toUpperCase() : "UNIFI" }} at
        <strong>{{ contactNumber }}</strong>
        or email us
        <a target="_blank" v-bind:href="'mailto:' + contactEmail">{{
          contactEmail
        }}</a>
      </h2>
      <div class="bigImg"></div>
    </div>
    <!--footer-->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      showTitle: false,
      gray: true,
      contactEmail: "",
      contactNumber: "",
      tenant: window.location.hostname
        .replace("m.", "")
        .split(".")[0]
        .split("testunifiproperty")[0]
        .split("unifiproperty")[0]
        .split("platform")[0]
    };
  },
  components: {
    headNav,
    footNav
  },
  created() {
    var that = this;
    that.getList({ callback: that.callback });
  },
  methods: {
    ...mapActions("contact", ["getList"]),
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        this.contactEmail = res.data.data.contactEmail;
        this.contactNumber = res.data.data.contactPhone;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    }
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  }
};
</script>

<style lang="scss" scoped>
.innerWrapper {
  width: 100%;
  padding: 1.04rem 0 0 0;
  box-sizing: border-box;
  margin: 0 auto;

  h1 {
    font-size: 0.56rem;
    line-height: 0.68rem;
    color: #2a2929;
    margin-bottom: 0.32rem;
    font-family: ProximaNova-Semibold;
    padding: 0.48rem 0.24rem 0 0.24rem;
    box-sizing: border-box;
  }

  h2 {
    font-size: 0.28rem;
    margin-bottom: 0.96rem;
    line-height: 0.42rem;
    color: #3f3f46;
    word-break: break-word;
    padding: 0 0.24rem;
    box-sizing: border-box;

    strong {
      color: #434043;
      font-family: ProximaNova-Semibold;
    }

    a {
      font-family: ProximaNova-Semibold;
      text-decoration: underline;
      color: #0391ff;
    }
  }

  .bigImg {
    width: 100%;
    height: 5rem;
    margin-bottom: 0.8rem;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-image: url("https://s3-ap-southeast-2.amazonaws.com/com.unifiproperty/files/images/lALPBF8a6aDY23PNA6HNBG0_1133_929.png");
  }
}
</style>



// WEBPACK FOOTER //
// src/components/more/contact.vue